import React, { useEffect, useState } from 'react';
import axios from "axios";
import base64 from "base-64"
import { Container } from "reactstrap"
import { set, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import Navbar from './Navbar'
import Footer from './Footer'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assests/css/help.css'
import IdleMonitor from './userAutoLogout';  //session management
const toastList = new Set();
const MAX_TOAST = 1;
const HelpSupport = () => {
    const history = useHistory();
    const [disButton, setDisButton] = useState(false)
    const [helpData, setHelpData] = useState("")
    const [loading, setLoading] = useState(false)
    const toastId = React.useRef(null);

    useEffect(() => {
    }, []);

    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const sendHelpApi = (payload) => {
        Promise.all([
            localStorage.getItem('userId'),
            localStorage.getItem('sToken')
        ]).then(async (res) => {
            let userId = JSON.parse(res[0]);
            let sToken = JSON.parse(res[1]);
            let header = base64.encode(`${userId}:${sToken}`);
            let security = `Basic ${header}`;

            const options = {
                headers: {
                    'Accept': 'application/json',
                    // 'Security': security,
                    'Content-Type': 'application/json',
                }
            };

            let helpUrl = `https://doorbell.io/api/applications/12845/submit?key=YPfFS4rMX2uaCAMo14nTukVu76ApZ7sFy2zHUkcn3W85C42ZIfbZCNrnqtv0VfXb`
            axios.post(helpUrl, payload, options)
                .then(response => {
                    console.log("Help API response", response)
                    if(response.status === 201){
                        // if (!toast.isActive(toastId.current)) {
                        //     toastId.current = toast.success("Message sent!!")
                        // }
                            if(toastList.size < MAX_TOAST) {
                              const id = toast.success("Message sent!!", {
                                // I'm using the onClose hook here to remove the id
                                // from the set
                                onClose: () => toastList.delete(id)
                              });
                              toastList.add(id);
                            }
                        setLoading(false)
                      
                        reset();
                     
                    }
                    else {
                        console.log("something went wrong in update activity API", response.data.errorMsg)
                        if (!toast.isActive(toastId.current)) {
                            toastId.current = toast.error("Something went wrong")

                        }
                      
                    }

                }).catch(err => {
                    console.log("error from update activity api", err)
                    if (err.response) {
                        // Request made and server responded
                        if(err.response.data === 'Invalid email address'){
                           
                            if (!toast.isActive(toastId.current)) {
                                toastId.current = toast.error("Invalid email address")
    
                            }
                        }
                     
                      } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log('Error', err.message);
                        
                        if (!toast.isActive(toastId.current)) {
                            toastId.current =toast.error("Something went wrong")

                        }                      }
                      setLoading(false);
                })

        }).catch((err) => {
            console.log("err", err)
        })
    }

    //update profile submit
    const onSubmit = async (data) => {
        
        setLoading(true);
        let submitHelpDetails = await {
            "email": JSON.parse(localStorage.getItem("email")),
            "message": data.helpData,
            "properties": {"userId" : JSON.parse(JSON.parse(localStorage.getItem("userId")))}
        }
        console.log("submitHelpDetails", submitHelpDetails)
     await sendHelpApi(submitHelpDetails)
   
    }

    return (
        <div className="helpmaindiv" style={{ fontFamily: "Poppins" }}>
            <div style={{ width: "100%", height: "100vh"}}>
                <Navbar />
                <Container fluid="true" className='help-container'>
                    <p className="help-heading">Help</p>

                    <div className="text-center bg-white helpmiddleDiv mx-auto">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div>
                                {/* Help input field */}
                                <div className="form-group">
                                    <p style={{ float: "left", fontSize:"14px", fontWeight:"400" }} className="form-group">You can submit support issues, feature requests or comments here.</p><br /><br />
                                    <span>
                                        <textarea className="help-form-control form-control" rows="12" type="text" placeholder="Enter your message here..." onChange={e => { setHelpData(e.target.value); }}  {...register("helpData", { required: true, maxLength: 500 })}></textarea>
                                        <div className="helperror">{errors.helpData?.type === 'required' && "*Please enter some text"}</div>
                                        <div className="helperror">{errors.helpData?.type === 'maxLength' && "*Limit exceeded"}</div>
                                    </span>
                                </div>
                                <br/>
                                <div className="btn-margin">
                                    <button type="submit" disabled={disButton} className="helpBtnDesg">
                                        {/* Send */}
                                        {(loading) ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Send"}
                                    </button>
                                </div>
                            </div>
                            <ToastContainer />
                        </form>
                 
                    </div>
                </Container>
                <IdleMonitor/>
                <Footer />
            </div>
        </div>
    );
}


export default HelpSupport;